"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispenseView = void 0;
require("./dispense-view.less");
const React = require("react");
const order_1 = require("shared/order");
const material_ui_1 = require("material-ui");
const icons_1 = require("client/components/icons");
const dispense_kpi_1 = require("client/modules/dispense/modules/dispense-view/components/dispense-kpi");
const filter_bar_1 = require("client/components/filter-bar");
const floating_page_1 = require("client/components/page/floating-page");
const kpi_header_1 = require("client/components/kpi-header");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const menu_1 = require("client/components/material/menu");
const switch_1 = require("client/components/material/switch");
const modal_1 = require("client/components/modal");
const payment_1 = require("client/modules/orders/modules/orders-detail/tabs/payment");
const router_1 = require("client/components/router");
// import { UiLoadingIndicator } from "client/components/ui"; // May use later.
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/users/store");
const claim_1 = require("shared/claim");
var SortPriority;
(function (SortPriority) {
    SortPriority[SortPriority["Dispensable"] = 1] = "Dispensable";
    SortPriority[SortPriority["Intendable"] = 2] = "Intendable";
    SortPriority[SortPriority["Undispenseable"] = 3] = "Undispenseable";
})(SortPriority || (SortPriority = {}));
var Modals;
(function (Modals) {
    Modals["Cancel"] = "cancel";
    Modals["Dispense"] = "dispense";
    Modals["Pay"] = "pay";
    Modals["AskPay"] = "askpay";
})(Modals || (Modals = {}));
let DispenseView = class DispenseView extends router_1.TabRouter {
    constructor(props) {
        super(props);
        this.complete = 0;
        this.incomplete = 0;
        this.selectedClaims = [];
        this.showComplete = false;
        this.showModal = false;
        this.sortBy = "status";
        this.sortDirection = "DESC";
        this.medDetails = [];
        this.filterText = "";
        this.loadOrders = async () => {
            var _a;
            const result = await store_1.ordersStore.loadReadyToDispense();
            this.ordersAll = (_a = result === null || result === void 0 ? void 0 : result.orders) !== null && _a !== void 0 ? _a : [];
            this.ordersFiltered = this.ordersAll;
        };
        this.handlePadSelectPatient = async (pad) => {
            var _a;
            const selectedOrder = this.selectedClaims[this.selectedIndex];
            const claimIds = selectedOrder.map((claimId) => claimId);
            const order = {
                id: this.orderId,
                site: {
                    id: this.site
                }
            };
            /** Make sure we're not trying to loop more than once. */
            window.clearInterval(this.sigIntervalId);
            const oldState = this.ordersFiltered.find(o => o.id === this.orderId);
            const oldSig = (_a = oldState === null || oldState === void 0 ? void 0 : oldState.billSignature) !== null && _a !== void 0 ? _a : null;
            await store_1.ordersStore.promptSignature(pad, claimIds, order);
            this.padsOpen = null;
            this.sigIntervalId = window.setInterval(async () => {
                var _a;
                // Unsure typing.
                await this.loadOrders();
                const newState = this.ordersFiltered.find(o => o.id === this.orderId);
                const newSig = (_a = newState === null || newState === void 0 ? void 0 : newState.billSignature) !== null && _a !== void 0 ? _a : null;
                if (oldSig !== newSig) {
                    window.clearInterval(this.sigIntervalId);
                    await store_1.ordersStore.updateSignatures(claimIds, newSig);
                    await this.loadOrders();
                }
            }, 2500);
        };
        this.renderPadMenu = () => {
            var _a, _b, _c, _d;
            return (React.createElement(menu_1.MaterialMenu, { open: Boolean(this.padsOpen), onClose: () => {
                    this.padsOpen = null;
                }, anchorEl: this.padsOpen },
                ((_b = (_a = store_1.ordersStore === null || store_1.ordersStore === void 0 ? void 0 : store_1.ordersStore.pads) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.length) === 0 && (React.createElement(material_ui_1.MenuItem, null,
                    React.createElement("a", { className: "pad-create-menu-link", href: "/pad", target: "__blank" }, "Click to create"))), (_d = (_c = store_1.ordersStore === null || store_1.ordersStore === void 0 ? void 0 : store_1.ordersStore.pads) === null || _c === void 0 ? void 0 : _c.value) === null || _d === void 0 ? void 0 :
                _d.map((p, index) => (React.createElement(material_ui_1.MenuItem, { key: index, onClick: async () => this.handlePadSelectPatient(p) }, p.name)))));
        };
        /** Temporary (lol) lazy workaround from creating a new column. */
        this.updateSelectedClaims = (index, claimId) => {
            if (!(typeof index === "number")) {
                this.selectedClaims = this.ordersAll.map((order) => order.claims
                    .map((claim) => {
                    if (claim.labelPrinted)
                        return claim.id;
                })
                    .filter(e => e));
            }
            else {
                const orderIndex = this.selectedClaims[index];
                const claimIndex = orderIndex.indexOf(claimId);
                if (claimIndex > -1) {
                    orderIndex.splice(claimIndex, 1);
                }
                else {
                    orderIndex.push(claimId);
                }
                this.selectedClaims[index] = [...orderIndex];
                this.selectedClaims = [...this.selectedClaims];
                this.forceUpdate();
            }
        };
        this.setOrderAndIndex = (orderId, indexId) => {
            this.selectedIndex = indexId;
            this.orderId = orderId;
        };
        this.handleClickSignature = (event, orderId, indexId) => {
            this.setOrderAndIndex(orderId, indexId);
            const order = {
                id: this.orderId,
                site: this.site
            };
            store_1.ordersStore.loadActivePads(order); // Async is causing even target issues.
            this.padsOpen = event.currentTarget;
        };
        this.handleClickModal = (modal, orderId, indexId) => {
            this.showModal = true;
            this.modalType = modal;
            this.setOrderAndIndex(orderId, indexId);
        };
        this.handleClickRow = (index) => {
            this.currentRowIndex = this.currentRowIndex === index ? null : index;
        };
        this.handleClickShowComplete = () => {
            this.showComplete = !this.showComplete;
            this.forceUpdate();
        };
        this.handleFilterSearch = (query) => {
            this.filterText = query;
            this.ordersFiltered = this.ordersAll.filter((order) => {
                const patient = order.patient;
                const patientFirstNoCase = patient.firstName.toLowerCase();
                const patientLastNoCase = patient.lastName.toLowerCase();
                const queryNoCase = query.toLowerCase();
                if (patientFirstNoCase.includes(queryNoCase) ||
                    patientLastNoCase.includes(queryNoCase)) {
                    return order;
                }
                return false;
            });
            this.forceUpdate();
        };
        this.renderFilter = () => (React.createElement("div", { className: "inventory__filter" },
            React.createElement(filter_bar_1.FilterBar, { callBack: (e) => this.handleFilterSearch(e), filterText: this.filterText, label: "Patient Search" })));
        this.renderModal = () => {
            switch (this.modalType) {
                case Modals.Cancel:
                    return this.cancelOrder();
                case Modals.Dispense:
                    return this.dispenseOrder();
                case Modals.Pay:
                    return this.payOrder();
                case Modals.AskPay:
                    return this.askPayOrder();
                default:
                    return React.createElement(React.Fragment, null); // Safety check.
            }
        };
        this.cancelModal = () => {
            this.showModal = false;
        };
        /** Confirms the cancelation of a selected order from the modal window. */
        this.confirmCancelOrder = async () => {
            const order = {
                claims: [],
                id: this.orderId
            };
            await store_1.ordersStore.dispenseOrder(order, false, "Provider Clicked Cancel");
            await this.loadOrders();
            this.cancelModal();
        };
        /** Confirms the cancelation of a selected order from the modal window. */
        this.confirmDispenseOrder = async () => {
            const activeClaims = this.selectedClaims[0];
            const claims = activeClaims.map((id) => ({ id }));
            const order = {
                claims,
                id: this.orderId
            };
            const result = await store_1.ordersStore.dispenseOrder(order);
            await this.loadOrders();
            this.modalType = Modals.AskPay;
            this.renderModal();
            this.forceUpdate();
            // Not sure if this is needed; need to talk to Thomas.
            // await ordersStore.print(dispensedClaims, "saveToDB");
        };
        /** Opens the cancel order confirmation modal window. */
        this.cancelOrder = () => {
            const modal = (React.createElement(modal_1.Modal, { onCancel: () => this.cancelModal() },
                React.createElement("h1", { style: { margin: "0 auto" } }, "Cancel Order"),
                React.createElement("h3", { style: { color: "red", margin: "0 auto" } }, "This order is about to be completely removed."),
                React.createElement("p", null,
                    "You're about to close this appointment without dispensing any medications. This action ",
                    React.createElement("strong", null, "can not"),
                    " be undone once it has been made."),
                React.createElement("h4", { style: { margin: "0 auto" } }, "Are you sure you really want to do this?"),
                React.createElement("div", { style: {
                        display: "flex",
                        justifyContent: "space-around",
                        marginTop: "2em",
                        width: "100%"
                    } },
                    React.createElement(button_1.MaterialButton, { onClick: async () => this.confirmCancelOrder(), primary: true }, "Cancel Order"),
                    React.createElement(button_1.MaterialButton, { onClick: () => this.cancelModal() }, "Go Back"))));
            return modal;
        };
        this.renderMedDetails = () => (React.createElement("ol", null, this.medDetails.map((c, i) => {
            const med = c.inventory;
            const desc = med.strengthDescription.length
                ? med.strengthDescription
                : med.name;
            return (React.createElement("li", { key: i },
                React.createElement("strong", null, med.package),
                " (",
                desc,
                ")"));
        })));
        this.dispenseOrder = () => {
            const modal = (React.createElement(modal_1.Modal, { onCancel: () => this.cancelModal() },
                React.createElement("h1", { style: { margin: "0 auto" } }, "Dispense"),
                React.createElement("p", null, "You're about to dispense this order. Once an order has been dispensed it can only be modified by an administrator."),
                this.renderMedDetails(),
                React.createElement("h4", { style: { margin: "1em auto" } }, "Are you sure this order is ready to be dispensed?"),
                React.createElement("div", { style: { display: "flex", justifyContent: "space-around" } },
                    React.createElement(button_1.MaterialButton, { onClick: async () => this.confirmDispenseOrder(), primary: true }, "Dispense Order"),
                    React.createElement(button_1.MaterialButton, { onClick: () => this.cancelModal() }, "Go Back"))));
            /** Display drugs that will be dispensed. */
            return modal;
        };
        this.askPayOrder = () => {
            const modal = (React.createElement(modal_1.Modal, { onCancel: () => this.cancelModal() },
                React.createElement("h1", { style: { margin: "0 auto" } }, "Process Payment"),
                React.createElement("p", null, "Would you like to process payment now?"),
                React.createElement("div", { style: { display: "flex", justifyContent: "space-around" } },
                    React.createElement(button_1.MaterialButton, { onClick: () => {
                            this.modalType = Modals.Pay;
                            this.renderModal();
                        }, primary: true }, "Process Payment"),
                    React.createElement(button_1.MaterialButton, { onClick: () => this.cancelModal() }, "Not Now"))));
            return modal;
        };
        this.payOrder = () => {
            const modal = (React.createElement(modal_1.Modal, { width: "70%", height: "70%", top: "15%", onCancel: () => this.cancelModal() },
                React.createElement(payment_1.PaymentTab, { params: [this.orderId.toString(10)], order: null }),
                React.createElement(button_1.MaterialButton, { style: { float: "right", maxWidth: "fit-content" }, onClick: () => this.cancelModal() }, "Close Popup")));
            return modal;
        };
        this.renderList = () => {
            var _a;
            const columns = [
                {
                    id: "firstName",
                    label: "First Name"
                },
                {
                    id: "lastName",
                    label: "Last Name"
                },
                {
                    id: "medCount",
                    label: "Medications"
                },
                {
                    id: "status",
                    label: "Status"
                },
                {
                    id: "button",
                    label: ""
                }
            ];
            return (React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: (e) => this.handleSort(e), order: this.sortDirection, orderBy: this.sortBy, rows: (_a = this.ordersFiltered) !== null && _a !== void 0 ? _a : [], renderRow: this.renderListRow }));
        };
        this.handleSort = (sortBy) => {
            if (sortBy === "medCount")
                return;
            if (this.sortBy === sortBy) {
                this.sortDirection = this.sortDirection === "ASC" ? "DESC" : "ASC";
            }
            else {
                this.sortBy = sortBy;
                this.sortDirection = "ASC";
            }
            this.currentRowIndex = null;
            /** Default sort should likely be by date..? */
            this.ordersFiltered = this.ordersFiltered.sort((a, b) => {
                const byPatient = sortBy === "lastName" || sortBy === "firstName";
                const propA = byPatient
                    ? a.patient[sortBy].toUpperCase()
                    : a[sortBy];
                const propB = byPatient
                    ? b.patient[sortBy].toUpperCase()
                    : b[sortBy];
                if (propA < propB)
                    return this.sortDirection === "DESC" ? 1 : -1;
                if (propA > propB)
                    return this.sortDirection === "DESC" ? -1 : 1;
                return 0;
            });
        };
        this.countComplete = (claims) => claims.filter((claim) => {
            const cStatus = claim.status;
            const done = [claim_1.ClaimStatus.Dispensed, claim_1.ClaimStatus.Intended];
            return done.includes(cStatus);
        }).length;
        this.renderListRow = (order, index) => {
            var _a, _b;
            const { claims, patient } = order;
            const hasComplete = this.countComplete(claims) > 0;
            const focused = this.currentRowIndex === index;
            const medCount = hasComplete ? this.countComplete(claims) : claims.length;
            const orderDone = order.status === order_1.OrderStatus.Done || hasComplete;
            const canDispense = !focused && !orderDone;
            const waitingForLabels = order.auditStatus === order_1.AuditStatus.Pending;
            const waitingForSignatures = claims.filter((claim) => !!claim.signature).length === 0;
            const waitingForDispense = !hasComplete && order.status === order_1.OrderStatus.Ready;
            const status = waitingForLabels
                ? "Awaiting Labels"
                : waitingForSignatures
                    ? "Awaiting Patient Signature"
                    : waitingForDispense
                        ? "Ready to Dispense"
                        : "Order Complete";
            if (orderDone && !this.showComplete)
                return false;
            return [
                React.createElement(React.Fragment, { key: index },
                    React.createElement(list_item_1.MaterialListItem, { className: `dispense--order-row${waitingForLabels ? "__yellow" : ""}`, key: index, onClick: () => this.handleClickRow(index) },
                        React.createElement(list_item_text_1.MaterialListItemText, { primary: (_a = patient.firstName) !== null && _a !== void 0 ? _a : "" }),
                        React.createElement(list_item_text_1.MaterialListItemText, { primary: (_b = patient.lastName) !== null && _b !== void 0 ? _b : "" }),
                        React.createElement(list_item_text_1.MaterialListItemText, { primary: medCount !== null && medCount !== void 0 ? medCount : "" }),
                        React.createElement(list_item_text_1.MaterialListItemText, { primary: status !== null && status !== void 0 ? status : "" }),
                        React.createElement(button_1.MaterialButton, { disabled: !canDispense, secondary: true }, orderDone ? "Complete" : focused ? "Waiting" : "Review")),
                    React.createElement(material_ui_1.Collapse, { in: focused }, this.renderRowEdit(order, index)))
            ];
        };
        this.sortClaims = (claims) => {
            const extendedClaims = claims
                .map((claim) => {
                var _a, _b;
                claim.details = {
                    lowQuantity: ((_b = (_a = claim.inventory) === null || _a === void 0 ? void 0 : _a.sites[0]) === null || _b === void 0 ? void 0 : _b.quantity) < claim.quantity,
                    printed: claim.labelPrinted === 2,
                    showPrinter: null
                };
                claim.details.showPrinter =
                    !claim.details.printed && !claim.details.lowQuantity;
                claim.priority = claim.details.printed
                    ? SortPriority.Dispensable
                    : claim.details.showPrinter
                        ? SortPriority.Undispenseable
                        : SortPriority.Intendable;
                return claim;
            })
                .sort((a, b) => {
                if (a.priority > b.priority)
                    return 1;
                else if (a.priority < b.priority)
                    return -1;
                return 0;
            });
            return extendedClaims;
        };
        this.renderRowEdit = (order, index) => {
            var _a, _b;
            if (!this.selectedClaims.length || !order.claims.length)
                return React.createElement(React.Fragment, null);
            const selectedClaims = this.selectedClaims[index];
            const allSigned = order.claims.filter((claim) => claim.signature && selectedClaims.includes(claim.id)).length === selectedClaims.length;
            const hasDispensed = this.countComplete(order.claims) > 0;
            const finishedClaims = [claim_1.ClaimStatus.Dispensed, claim_1.ClaimStatus.Intended];
            return (React.createElement("div", { style: {
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center"
                } },
                React.createElement("div", { style: { width: "50%" }, key: Math.random() }, (_b = this.sortClaims((_a = order.claims) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.map((claim, i, arr) => {
                    var _a, _b;
                    const { lowQuantity, showPrinter } = claim.details;
                    const hasLots = !!claim.claimLots;
                    const hasSignature = !!claim.signature;
                    const isIntended = claim.status === claim_1.ClaimStatus.Intended;
                    const isSelected = selectedClaims.includes(claim.id);
                    const inventory = claim.inventory;
                    const drugName = inventory.strengthDescription.length
                        ? inventory.strengthDescription
                        : inventory.name.length
                            ? inventory.name
                            : "MISSING_NAME";
                    if (hasDispensed && !finishedClaims.includes(claim.status))
                        return React.createElement(React.Fragment, null);
                    return (React.createElement(React.Fragment, null,
                        claim.priority !== ((_a = arr[i - 1]) === null || _a === void 0 ? void 0 : _a.priority) && (React.createElement("h2", null, claim.priority === SortPriority.Dispensable
                            ? "Available to Dispense"
                            : claim.priority === SortPriority.Intendable
                                ? "Intent to Dispense"
                                : "Labels Require Printing")),
                        React.createElement("div", { style: {
                                marginLeft: "2em",
                                opacity: isSelected || isIntended ? 1 : 0.3
                            }, className: `dispense--row-drug ${isSelected && hasSignature
                                ? hasLots && !lowQuantity
                                    ? "dispense--row-drug__green"
                                    : "dispense--row-drug__blue"
                                : isIntended
                                    ? "dispense--row-drug__blue"
                                    : ""}`, key: i },
                            React.createElement("div", { className: "dispense--row-drug-text" },
                                React.createElement("span", null,
                                    React.createElement("b", null, "NDC:"),
                                    " ", (_b = inventory.package) !== null && _b !== void 0 ? _b : ""),
                                React.createElement("span", { style: { marginLeft: "2em" } },
                                    React.createElement("b", null, "Drug:"),
                                    " ",
                                    drugName)),
                            !hasDispensed && (React.createElement("div", { style: { alignItems: "center", display: "flex" } },
                                lowQuantity && (React.createElement(icons_1.WarningIcon, { "data-tip": "Out of stock - will be marked as Intend to Dispense", "data-place": "right", fill: "orange", style: { marginRight: "1em" } })),
                                showPrinter && (React.createElement(icons_1.PrinterIcon, { fill: "red", style: { marginRight: "2em" } })),
                                !showPrinter && (React.createElement(button_1.MaterialButton, { onClick: () => this.updateSelectedClaims(index, claim.id), primary: isSelected }, isSelected ? "Remove" : "Add")))))));
                })),
                React.createElement("div", { style: {
                        display: "flex",
                        flexDirection: "column",
                        margin: "2em",
                        textAlign: "center"
                    } }, !hasDispensed ? ( // We only want to show this if they CAN dispense.
                React.createElement(React.Fragment, null,
                    (order === null || order === void 0 ? void 0 : order.billSignature) && allSigned ? ( // Signature Display
                    React.createElement("div", { style: {
                            border: "1px solid whitesmoke",
                            display: "block",
                            height: "3em",
                            margin: ".5em auto",
                            width: "13em"
                        } },
                        React.createElement("img", { src: order.billSignature, style: { maxHeight: "13em", maxWidth: "13em" } }))) : (React.createElement(button_1.MaterialButton, { onClick: (e) => this.handleClickSignature(e, order.id, index), secondary: true }, "Collect Signature")),
                    this.renderPadMenu(),
                    React.createElement("div", { style: { margin: "1em auto" } },
                        React.createElement(button_1.MaterialButton, { style: { marginRight: "1em" }, onClick: () => this.handleClickModal(Modals.Cancel, order.id) }, this.showComplete && order.autoReverse
                            ? "Uncancel"
                            : "Cancel"),
                        React.createElement(button_1.MaterialButton, { primary: true, onClick: () => {
                                this.medDetails = order.claims.filter((c) => selectedClaims.includes(c.id));
                                this.handleClickModal(Modals.Dispense, order.id, index);
                            }, disabled: !allSigned || !selectedClaims.length }, this.showComplete && order.autoReverse ? "" : "Dispense")))) : (React.createElement(button_1.MaterialButton // If we DID dispense, show this instead.
                , { secondary: true, onClick: () => this.handleClickModal(Modals.Pay, order.id) }, "Manage Payment"))),
                React.createElement("div", { style: { marginBottom: "1em" } },
                    React.createElement("h4", null, "Summary:"),
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement("b", null,
                                "Dispens",
                                hasDispensed ? "ed" : "ing"),
                            ":",
                            " ",
                            selectedClaims.length),
                        React.createElement("li", null,
                            React.createElement("b", null, "Subtotal"),
                            ": $",
                            order.claims
                                .reduce((price, claim) => {
                                var _a;
                                const selected = selectedClaims.includes(claim.id);
                                return selected
                                    ? price + ((_a = claim.patientAmount / 100) !== null && _a !== void 0 ? _a : 0)
                                    : price;
                            }, 0)
                                .toFixed(2))))));
        };
    }
    render() {
        var _a, _b, _c, _d, _e;
        return (React.createElement("div", { className: "dispense--wrapper" },
            React.createElement(React.Fragment, null,
                React.createElement(kpi_header_1.KpiHeader, { center: false },
                    React.createElement(dispense_kpi_1.DispenseKpi
                    /** Going to need to fix this stuff. */
                    , { 
                        /** Going to need to fix this stuff. */
                        dispenseKpi: {
                            complete: (_a = this.complete) !== null && _a !== void 0 ? _a : 0,
                            provider: (_b = this.provider) !== null && _b !== void 0 ? _b : null,
                            remaining: (_c = this.incomplete) !== null && _c !== void 0 ? _c : 0,
                            siteName: (_e = (_d = this.site) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : ""
                        } })),
                React.createElement(floating_page_1.FloatingPage, null,
                    React.createElement("div", { className: "dispense" },
                        React.createElement("div", { className: "dispense--header" },
                            this.renderFilter(),
                            React.createElement(switch_1.MaterialSwitch, { label: "Show Completed Appointments", value: "false", onChange: this.handleClickShowComplete })),
                        React.createElement("div", { className: "dispense--result" }, this.renderList()),
                        this.showModal && this.renderModal())))));
    }
    async componentDidMount() {
        this.user = store_2.usersStore.user.value;
        this.site = this.user.site;
        await this.loadOrders();
        await this.updateSelectedClaims();
        this.loadIntervalId = window.setInterval(async () => {
            // Unsure typing.
            await this.loadOrders();
        }, 60 * 1000);
    }
    componentWillUnmount() {
        /** Make sure we kill this trash if we leave the page. */
        window.clearInterval(this.loadIntervalId);
        window.clearInterval(this.sigIntervalId);
    }
};
__decorate([
    mobx_1.observable
], DispenseView.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "modalType", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "orderId", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "ordersAll", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "ordersFiltered", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "padsOpen", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "complete", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "incomplete", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "provider", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "selectedClaims", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "selectedIndex", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "showComplete", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "showModal", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "sortBy", void 0);
__decorate([
    mobx_1.observable
], DispenseView.prototype, "sortDirection", void 0);
DispenseView = __decorate([
    mobx_react_1.observer
], DispenseView);
exports.DispenseView = DispenseView;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dispense/modules/dispense-view/dispense-view.tsx
// module id = 3380
// module chunks = 0